import { render, staticRenderFns } from "./TableCaseTree.vue?vue&type=template&id=7511f724&scoped=true&"
import script from "./TableCaseTree.vue?vue&type=script&lang=ts&"
export * from "./TableCaseTree.vue?vue&type=script&lang=ts&"
import style0 from "./TableCaseTree.vue?vue&type=style&index=0&id=7511f724&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7511f724",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VSimpleTable})
